import { Typography } from '@euler/app/components/typography';
import { ApdmImportSummary } from '@euler/functions/apdm/import/importState';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { Pressable, View } from 'react-native';
import { useTheme } from 'styled-components';
import { formatPercent } from '../../functions/formatPercent';

/** One quiet line for what was left out, with a way into the details. */
export function LeftOutLine({
  leftOut,
  expanded,
  onToggle,
}: {
  leftOut: ApdmImportSummary['leftOut'];
  expanded: boolean;
  onToggle: () => void;
}) {
  const theme = useTheme();
  const { rpx } = useResponsiveContext();
  const parts = [
    leftOut.rows
      ? `${leftOut.rows} 行未导入（${formatPercent(
          leftOut.rows,
          leftOut.totalRows,
        )}）`
      : '所有行都已导入',
    leftOut.unclassifiedDocuments
      ? `${leftOut.unclassifiedDocuments} 单含未识别的项目，只计来店不计保养`
      : null,
  ].filter((part): part is string => part !== null);
  return (
    <View
      style={{
        marginTop: rpx(12),
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: rpx(8),
      }}
    >
      <Typography.Text size={rpx(13)} color={theme.label.color}>
        {parts.join('；')}
      </Typography.Text>
      <Pressable
        accessibilityRole="button"
        accessibilityState={{ expanded }}
        onPress={onToggle}
      >
        <Typography.Text size={rpx(13)} color={theme.link}>
          {expanded ? '收起详情' : '查看详情'}
        </Typography.Text>
      </Pressable>
    </View>
  );
}
